/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { Time as Tm } from '../Styles/index'

const Wrapper: React.FC<WrapperProps> = ({ styles, accentColor, children }) => {
  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <div
          css={{
            '--rw-accent': accentColor,
            ...getStyles('wrapper', {}),
          }}
        >
          <div css={getStyles('innerWrapper', {})}>{children}</div>
        </div>
      )}
    </StyledComponent>
  )
}

export default Wrapper

type WrapperProps = {
  accentColor?: string
  styles?: Tm.StylesObj
}
